export default "__VITE_ASSET__a52386e2__"